<template>
  <div :class="$style.table_of_contents">
    <div :class="$style.title">目次</div>
    <div :class="$style.content">
      <AtomsConsumerLink
        v-for="(content, index) of tableOfContents"
        :key="content"
        v-scroll-to="`#heading${index + 1}`"
        :class="$style.content_text"
      >
        <span :class="$style.num">{{ index + 1 }}.</span>{{ content }}
      </AtomsConsumerLink>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  pageParts?: { layout_type?: string; detail: { title?: string } }[]
}

const props = withDefaults(defineProps<Props>(), {
  pageParts: () => [],
})

const tableOfContents = computed(() => {
  const contents = []
  for (const pagePart of props.pageParts) {
    if (pagePart.layout_type === "editor_text" && pagePart.detail.title) {
      const tags = pagePart.detail.title.match(/<h2.+?<\/h2>/g)
      if (tags !== null) contents.push(...tags.map((tag) => tag.replace(/<[^>]+>/g, "")))
    }
  }
  return contents
})
</script>

<style scoped module lang="scss">
.table_of_contents {
  @include container-sm;
  background: $secondary-10;
  padding: 2rem !important;
  .title {
    @include main-font;
    font-size: $font-size-18;
    margin-bottom: 1rem;
    color: $primary;
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
    .content_text {
      cursor: pointer;
      font-size: $font-size-14;
      display: flex;
      gap: 0.5rem;
    }
  }
}
</style>
